import { Dashboard } from '@mui/icons-material';
import { IntlShape } from 'react-intl';
import { TaskPreciseDTO } from '../../api/task';
import { formatDateTime } from '../date';
import { translateTaskType } from '../language';
import { getDocumentName, getDocumentUrl } from '../records/documents/document';
import { getTaskStatus } from '../status';
import { EntityInformation } from './types/EntityInformation';

export const TaskIcon = Dashboard;

export const getTaskInformation = (task: TaskPreciseDTO, intl: IntlShape): EntityInformation => {
    return {
        url: getDocumentUrl(task),
        name: getDocumentName(task, intl),
        title: task.document?.title ?? '',
        status: getTaskStatus(task, intl),
        creation: null,
        details: [
            {
                labelKey: 'task.field.createdDate',
                value: formatDateTime(task.createdDate, intl),
            },
            {
                labelKey: 'document.field.type',
                value: translateTaskType(task.type, intl.locale).typeName,
                type: true,
            },
        ],
    };
};
